import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSpeechBubbleStack12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#SpeechBubbleStack12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M3 7.5V6.395l-1.1.11-.35.035A.5.5 0 0 1 1 6.043V2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3.7a.5.5 0 0 1-.5.5H4.498l-.296.314L3 8.285zm4.5.2H4.929L3.727 8.973c-.57.603-1.545.284-1.705-.47A1 1 0 0 1 2 8.286V7.5l-.35.035A1.5 1.5 0 0 1 0 6.043V2.5A1.5 1.5 0 0 1 1.5 1h6A1.5 1.5 0 0 1 9 2.5v3.7a1.5 1.5 0 0 1-1.5 1.5M6.858 10H4.284l1.04-1h1.912l.283.25 1.257 1.108V9h1.745a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H10V4h.521a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-.745v.911a.75.75 0 0 1-1.246.563z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="SpeechBubbleStack12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconSpeechBubbleStack12);
